<template>
  <NuxtLayout>
    <DynamicDialog />
    <ConfirmDialog />
    <Toast />
    <NuxtPage />
  </NuxtLayout>
</template>
<script setup lang="ts">
  const layout = useLayout();
</script>